import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const exportStyledExcel = async (data, fileName, headerMessage = null, firstRowGreen = false) => {
  if (!data || data.length === 0) {
    throw new Error('No data provided for export.');
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Sheet1');

  let currentRowIndex = 1;
  if (headerMessage) {
    const messageRow = worksheet.addRow([headerMessage]);
    messageRow.eachCell((cell) => {
      cell.font = { bold: true, size: 12, color: { argb: 'FF000000' } };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });
    if (Object.keys(data[0]).length > 1) {
      worksheet.mergeCells(`A${currentRowIndex}:${String.fromCharCode(64 + Object.keys(data[0]).length)}${currentRowIndex}`);
    }
    currentRowIndex++; 
  }

  const headerRowKeys = Object.keys(data[0]);
  const headerRow = worksheet.addRow(headerRowKeys);

  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FF000000' } }; 
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF00FF00' }, 
    };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  });

  data.forEach((item, index) => {
    const rowData = headerRowKeys.map(header => item[header]);
    worksheet.addRow(rowData);

  });

  worksheet.columns.forEach(column => {
    let maxLength = 5; 
    column.eachCell({ includeEmpty: true }, cell => {
      const length = cell.value ? cell.value.toString().length : 0;
      if (length > maxLength) {
        maxLength = length;
      }
    });
    column.width = Math.min(maxLength + 2, 15); 
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, fileName);
};
